import Grid from '@mui/material/Grid';
import { useRouter } from 'next/router';

import GridContainer from '@/components/Layout/GridContainer/GridContainer';
import { SpacingContainer } from '@/components/SpacingContainer/SpacingContainer';
import type { BlogPageType } from '@/contentful/api/api.types';

import useStyles from './BlogCategorySplit.styles';
import SplitSection from './SplitSection/SplitSection';

type BlogCategorySplitProps = {
  categoryTitle1: string;
  categoryTitle2: string;
  articleColumn1: BlogPageType[];
  articleColumn2: BlogPageType[];
  column1CategoryUrl: string;
  column2CategoryUrl: string;
};

const BlogCategorySplit = ({
  categoryTitle1,
  articleColumn1,
  column1CategoryUrl,
  categoryTitle2,
  articleColumn2,
  column2CategoryUrl,
}: BlogCategorySplitProps) => {
  const { classes } = useStyles();
  const router = useRouter();

  const [featuredFirst, ...firstArticles] = articleColumn1;
  const [featuredSecond, ...secondArticles] = articleColumn2;
  const clickHandler = (url: string) => {
    if (url) {
      router.push(url);
    }
  };

  return (
    <SpacingContainer
      isFeatured
      className={classes.divWrapper}
      data-testid='blogCategorySplit'
    >
      <GridContainer fixed gridProps={{ className: classes.grid }}>
        <Grid
          size={{
            xs: 12,
            sm: 6,
          }}
        >
          <SplitSection
            heading={categoryTitle1}
            featuredArticle={featuredFirst}
            additionalArticles={firstArticles}
            onClick={() => clickHandler(column1CategoryUrl)}
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            sm: 6,
          }}
        >
          <SplitSection
            heading={categoryTitle2}
            featuredArticle={featuredSecond}
            additionalArticles={secondArticles}
            onClick={() => clickHandler(column2CategoryUrl)}
          />
        </Grid>
      </GridContainer>
    </SpacingContainer>
  );
};

export default BlogCategorySplit;
